class TwilioPhone {
  startCall (VueApp, user) {
    if (true) return
    // Check if there is an ongoing call
    if (VueApp.$store.state.phone.ongoing) {
      return
    }
    console.log('CALLING')
    console.log(user)
    VueApp.$store.commit('phone/startCall', user)
    VueApp.$sdk.get('/twilio/token', {
      token: VueApp.$store.state.session.sessionToken
    } , r => {
      if (r.error) {
        return
      }
      Twilio.Device.setup(r.token) // eslint-disable-line no-undef
    })

    Twilio.Device.ready(function (device) { // eslint-disable-line no-undef
      console.log('TWILIO READY')
      console.log(device)

     
      let connection = Twilio.Device.connect({ // eslint-disable-line no-undef
        'phone_number': user.phone
      })
      console.log(connection)
    })
    Twilio.Device.error(function (error) { // eslint-disable-line no-undef
      console.log(error)
      console.log('TWILIO ERROR: ' + error.message)
      // VueApp.$store.commit('phone/endCall')
    })
    Twilio.Device.connect(function (connection) { // eslint-disable-line no-undef
      console.log('TWILIO CONNECT')
      console.log(connection)
    })
    Twilio.Device.disconnect(function (connection) { // eslint-disable-line no-undef
      console.log('TWILIO DISCONNECT')
      console.log(connection)
      VueApp.$store.commit('phone/endCall')
    })
    Twilio.Device.offline(function (device) { // eslint-disable-line no-undef
      console.log('TWILIO OFFLINE')
      console.log(device)
      // VueApp.$store.commit('phone/endCall')
    })
    Twilio.Device.cancel(function (connection) { // eslint-disable-line no-undef
      console.log('TWILIO CANCEL')
      console.log(connection)
      // VueApp.$store.commit('phone/endCall')
    })
  }

  endCall (VueApp) {
    Twilio.Device.disconnectAll() // eslint-disable-line no-undef
  }

  toggleMute (VueApp) {
    let connection = Twilio.Device.activeConnection()
    let isMute = connection.isMuted()

    connection.mute ( (mute, connection) => {
      VueApp.$store.commit('phone/setMute', !isMute)
      console.log('MUTE')
      console.log(mute)
      console.log(connection)
    })

    connection.mute(!isMute)
  }
}

export default TwilioPhone



// WEBPACK FOOTER //
// ./src/modules/plugins/twilio-phone.js